package one.healthium.healthKit.data

import androidx.lifecycle.Lifecycle
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.filter
import kotlinx.coroutines.flow.onStart
import kotlinx.coroutines.launch
import one.healthium.base.preferences.AppPreferences
import one.primehealth.app.AppLifecycleChannel
import kotlin.time.Instant


class HealthKitHelper(
    private val manager: HealthKitManager,
    private val appPreferences: AppPreferences,
    private val appLifecycleChannel: AppLifecycleChannel
) {
    private val _healthKitStatus = MutableStateFlow(HealthKitStatus.UNAVAILABLE)
    val healthKitStatus = _healthKitStatus.asStateFlow()

    private val scope = CoroutineScope(Dispatchers.Default + SupervisorJob())

    init {
        scope.launch { _healthKitStatus.value = isHealthKitAvailable() }
    }

    internal suspend fun isHealthKitAvailable(): HealthKitStatus {
        val status = appPreferences.didReactToHKBanner
        if (status == false) {
            return HealthKitStatus.REJECTED
        }
        return manager.getHealthKitStatus()
    }

    internal fun refreshHKStatus() {
        _healthKitStatus.value = HealthKitStatus.CONNECTING
        scope.launch { _healthKitStatus.value = manager.getHealthKitStatus() }
    }

    internal fun launchHealthApp() {
        manager.launchHealthApp()
    }

    fun getDailySteps(): Flow<Long?> {
        return combine(
            appLifecycleChannel.lifecycle.filter { it.isAtLeast(Lifecycle.State.STARTED) },
            _healthKitStatus
                .filter { it == HealthKitStatus.CONNECTED }
        ) { _, _ ->
            manager.getSteps()
        }
            .onStart { emit(null) }
    }

    fun processSkipRequest() {
        appPreferences.didReactToHKBanner = false
        _healthKitStatus.value = HealthKitStatus.REJECTED
    }

    suspend fun connectToHealthKit() {
        appPreferences.didReactToHKBanner = true
        _healthKitStatus.value = HealthKitStatus.CONNECTING
        manager.connectToHealthKit()
        refreshHKStatus()
    }

    suspend fun logWeight(weight: Float) {
        manager.logWeight(weight)
    }

    suspend fun logWater(amount: Float) {
        manager.logWater(amount)
    }

    suspend fun getWeightFromDate(date: Instant): List<HKWeightLogRecord> {
        return manager.getWeightLogSince(date)
    }
}
